import { Modal, Progress, Typography } from "antd";
import React, { useEffect, useRef, useState } from "react";
import CustomButton from "../../../resuableComponents/CustomButton";
import "./retryModal.css";
import RetryProgressButton from "./RetryProgressButton";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { autoRetryAttemptedEvent, autoRetryCancelledEvent } from "../../../../Utils/uiAnalytics";
import TranslateText from "../../../resuableComponents/TranslateText";

const COUNTDOWN_SECONDS = 5;

const RetryModal = ({
    icon,
    title,
    desc,
    showModal,
    onRetry,
    onCancel,
    bottomText,
}) => {
    const { t } = useTranslation();
    const [progress, setProgress] = useState(0);
    const [isCancelDisabled, setIsCancelDisabled] = useState(false);
    const intervalRef = useRef(null);
    const startTimeRef = useRef(null);
    const retryPaymentLoading = useSelector((state) => state.paymentInitiation.retryPaymentLoading);

    useEffect(() => {
        if (showModal) {
            autoRetryAttemptedEvent();
        }
    }, [showModal]);

    useEffect(() => {
        if (!showModal) {
            clearInterval(intervalRef.current);
            setProgress(0);
            setIsCancelDisabled(false);
            return;
        }

        startTimeRef.current = performance.now();

        intervalRef.current = setInterval(() => {
            const elapsed = performance.now() - startTimeRef.current;
            const pct = Math.min((elapsed / (COUNTDOWN_SECONDS * 1000)) * 100, 100);
            setProgress(pct);

            if (pct >= 100) {
                clearInterval(intervalRef.current);
                setIsCancelDisabled(true);
                // onRetry?.();
            }
        }, 50);

        return () => clearInterval(intervalRef.current);
    }, [showModal]);

    // const handleCancel = () => {
    //     clearInterval(intervalRef.current);
    //     setProgress(0);
    //     setIsCancelDisabled(false);
    //     onCancel?.();
    // };

    const handleCancelClick = () => {
        autoRetryCancelledEvent();
        onCancel()
    }

    // const handleRetry = () => {
    //     clearInterval(intervalRef.current);
    //     setProgress(0);
    //     setIsCancelDisabled(false);
    //     onRetry?.();
    // };

    const remainingSeconds = Math.ceil(
        COUNTDOWN_SECONDS - (progress / 100) * COUNTDOWN_SECONDS
    );



    return (
        <Modal
            centered
            open={showModal}
            footer={null}
            closable={false}
            width={"416px"}
        >
            <div className="domestic-error-root" >
                <div className="domestic-error-header-conatiner" >

                    <div className="domestic-error-header-content dynamic-font-styling" style={{ gap: "15px" }}>
                        <Typography className="domestic-error-header-title" style={{ display: "flex", gap: "8px", alignItems: "center", justifyContent: "center", fontSize: "17px" }}>
                            <div className="domestic-error-header-logo">{icon}</div>
                            {title}
                        </Typography>
                        <Typography
                            className="domestic-error-header-desc"
                            style={{ whiteSpace: "pre-wrap", fontSize: "13px", textAlign: "center" }}
                        >
                            {desc}
                        </Typography>
                    </div>
                </div>
                {/* Progress bar */}


                <div className="domestic-error-footer" style={{ marginTop: "15px" }}>
                    <RetryProgressButton
                        duration={5}
                        block={true}
                        text={<>
                            {retryPaymentLoading ? t("RETRYING_TEXT") : <> <TranslateText label={"RETRYING_IN"}>Payment failed with</TranslateText> {remainingSeconds}s  <span style={{ display: "inline-block", margin: "0 4px" }}> • </span>   <TranslateText label={"CLICK_TO_STOP"}>Click to Stop</TranslateText> </>}

                        </>}
                        onComplete={onRetry}
                        onStop={handleCancelClick}
                    />

                </div>
                {bottomText &&
                    <div className="domestic-error-root" style={{ padding: "8px 24px", paddingTop: "15px" }}>
                        <div className="domestic-error-header-conatiner" style={{ justifyContent: "center" }}>

                            <Typography
                                className="domestic-error-header-desc"
                                style={{ whiteSpace: "pre-wrap", fontSize: "12px", }}
                            >
                                {bottomText}
                            </Typography>
                        </div>
                    </div>}
            </div>

        </Modal>
    );
};

export default RetryModal;